import React from 'react';

const SpaceDetailsLoader = () => (
    <div className="my-space-details host-dashboard">
      <div className="content">
        <div className="container custom-container">
          
          <div className="header-content" style={{ borderBottom: 'none', paddingBottom: '0' }}>
             <div className="top-row" style={{ width: '100%', display: 'flex', alignItems: 'center', gap: '12px' }}>
                <div className="loading-shimmer" style={{ width: '120px', height: '14px', borderRadius: '4px', backgroundColor: '#f0f0f0' }} />
                <div className="loading-shimmer" style={{ width: '80px', height: '20px', borderRadius: '4px', backgroundColor: '#f0f0f0' }} />
                <div className="loading-shimmer" style={{ width: '70px', height: '20px', borderRadius: '12px', marginLeft: 'auto', backgroundColor: '#f0f0f0' }} />
             </div>
             
             <div className="loading-shimmer" style={{ width: '50%', height: '28px', marginTop: '16px', borderRadius: '4px', backgroundColor: '#f0f0f0' }} />
             
             <div className="location-info" style={{ display: 'flex', gap: '8px', marginTop: '12px' }}>
                <div className="loading-shimmer" style={{ width: '150px', height: '16px', borderRadius: '4px', backgroundColor: '#f0f0f0' }} />
             </div>
          </div>
          
          <div className="content">
            <div className="images-section" style={{ marginTop: '24px' }}>
              <div className="space-images-grid grid-5">
                 <div className="space-image-item loading-shimmer" style={{ backgroundColor: '#f0f0f0', border: 'none', cursor: 'default' }}></div>
                 <div className="space-image-item loading-shimmer" style={{ backgroundColor: '#f0f0f0', border: 'none', cursor: 'default' }}></div>
                 <div className="space-image-item loading-shimmer" style={{ backgroundColor: '#f0f0f0', border: 'none', cursor: 'default' }}></div>
                 <div className="space-image-item loading-shimmer" style={{ backgroundColor: '#f0f0f0', border: 'none', cursor: 'default' }}></div>
                 <div className="space-image-item loading-shimmer" style={{ backgroundColor: '#f0f0f0', border: 'none', cursor: 'default' }}></div>
              </div>
            </div>
          </div>

        </div>
      </div>
    
      <style>{`
        @keyframes shimmer {
          0% { opacity: 0.6; }
          50% { opacity: 1; }
          100% { opacity: 0.6; }
        }
        .loading-shimmer {
          animation: shimmer 1.5s infinite ease-in-out;
        }
      `}</style>
  </div>
);

export default SpaceDetailsLoader;